const Words = {
  "常用语-快捷回复工具": "常用語-快捷回覆工具",
  "在吗？在吗？在吗？重要的话说三遍。": "在嗎？在嗎？在嗎？重要的話說三遍。",
  "好久没聊天了，快来和我说说话～": "好久沒聊天了，快來和我說說話～",
  "好的，就这么说定了。": "好的，就這麼說定了。",
  "感恩的心，感谢有你。": "感恩的心，感謝有你。",
  "糟糕！是心动的感觉！": "糟糕！是心動的感覺！",
  "心疼地抱抱自己，我太难了！": "心疼地抱抱自己，我太難了！",
  "没关系，别在意，事情过去就过去了。": "沒關係，別在意，事情過去就過去了。",
  "早上好，今天也是让人期待的一天呢！": "早上好，今天也是讓人期待的一天呢！",
  "熬夜有什么用，又没人陪你聊天，早点休息吧。": "熬夜有什麼用，又沒人陪你聊天，早點休息吧。"
}

export default Words;
